import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=2ff62442&scoped=true"
import script from "./AppForm.vue?vue&type=script&lang=js"
export * from "./AppForm.vue?vue&type=script&lang=js"
import style0 from "./AppForm.vue?vue&type=style&index=0&id=2ff62442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff62442",
  null
  
)

export default component.exports